import { createAsyncThunk } from "@reduxjs/toolkit";
import {GET_ADMIN_PANEL_PRODUCT, PRODUCT_APPROVE, PRODUCT_REJECT} from "./AdminPanel.type";
import AdminPanelService from "../services/adminPanel.service";


export const getAdminPanelProduct = createAsyncThunk(
    GET_ADMIN_PANEL_PRODUCT,
    async () =>{
        const response = await AdminPanelService.getAdminPanelProduct();
        return response.data;
    }
)
export const productApprove = createAsyncThunk(
    PRODUCT_APPROVE,
    async (model:any) =>{
        const response = await AdminPanelService.productApprove(model);
        return response.data;
    }
)
export const productReject = createAsyncThunk(
    PRODUCT_REJECT,
    async (model:any) =>{
        const response = await AdminPanelService.productReject(model);
        return response.data;
    }
)
